import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import FooterCss from "./FooterCss.js";
class Footer extends s {
  static get styles() {
    return [FooterCss];
  }
  static get properties() {
    return {
      text: { type: String }
    };
  }
  render() {
    return y`
      <footer>
        <span class="text">
          ${this.text}
        </span>
        <slot></slot>
      </footer>
    `;
  }
}
customElements.define("isceco-footer", Footer);
export { Footer };
